/* SunMark — the habishine app mark: a cream rising sun on the warm amber
   ground, the same artwork as the app icon (docs/brand-assets/app-icon.svg). */
export function SunMark({ size = 66 }: { size?: number }) {
  const r = 20 * (120 / size);
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden>
      <defs>
        <linearGradient id="habGround" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFCF57" />
          <stop offset="1" stopColor="#F5851C" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="120" height="120" rx={r} fill="url(#habGround)" />
      <g stroke="#FFF3DD" strokeWidth={7} strokeLinecap="round" strokeLinejoin="round">
        <line x1="34" y1="69" x2="25.4" y2="64" /><line x1="45" y1="58" x2="40" y2="49.4" /><line x1="60" y1="54" x2="60" y2="44" />
        <line x1="75" y1="58" x2="80" y2="49.4" /><line x1="86" y1="69" x2="94.6" y2="64" />
      </g>
      <path d="M36 84 A24 24 0 0 1 84 84 Z" fill="#FFFDF8" />
      <line x1="20" y1="84" x2="100" y2="84" stroke="#FFF3DD" strokeWidth={7} strokeLinecap="round" />
    </svg>
  );
}
